import { APIResponseCodeInterface } from "./Interfaces.constants"

export const CIPHER_KEY = 'MF-Central2023'

export const APIResponseCodes: APIResponseCodeInterface = {
    SUCCESS : '10000',
    FAILURE : '10001',
    RETRY : '10002',
    INVALID_ACCESS_TOKEN : '10003',
    INVALID_ENCRYPTED_INPUT: '10004',
    SERVER_ERROR: '10005'
}

export const tableKeys = {
    headers: [
        {
            column_name: 'Key',
            key: 'key',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Value',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
    params: [
        {
            column_name: 'Key',
            key: 'key',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Value',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],

    docReqTableKeys: [
        {
            column_name: 'column name',
            key: 'columnName',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'input',
            key: 'input',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'data type',
            key: 'dataType',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'mandatory',
            key: 'required',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'description',
            key: 'description',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
    docResTableKeys: [
        {
            column_name: '',
            key: 'first_column',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'output',
            key: 'output',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'description',
            key: 'description',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
    

    
}

export const tableKeystryIT = {
    headers: [
        {
            column_name: 'Request Headers',
            key: 'key',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Expected Values',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
    

    docReqTableKeys: [
        {
            column_name: 'Client',
            key: 'column Name',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'input',
            key: 'input',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'data type',
            key: 'dataType',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'mandatory',
            key: 'required',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'description',
            key: 'description',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
    docResTableKeys: [
        {
            column_name: '',
            key: 'first_column',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'output',
            key: 'output',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'description',
            key: 'description',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
      
}

export const tableKeystryRun = {
    headers: [
        {
            column_name: 'Request Headers',
            key: 'key',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Expected Values',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
    

    docReqTableKeys: [
        {
            column_name: 'Client',
            key: 'column Name',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'input',
            key: 'input',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'data type',
            key: 'dataType',
            isText: true,
            isJSX: false,
            isClickable: false
        },
      
    ],
    docResTableKeys: [
        {
            column_name: '',
            key: 'first_column',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'output',
            key: 'output',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'description',
            key: 'description',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
      
}
export const tableKeysDocument = {
    headers: [
        {
            column_name: 'Category',
            key: 'key',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Error Message',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Error Code',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
    

    docReqTableKeys: [
        {
            column_name: 'Client',
            key: 'column Name',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'input',
            key: 'input',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'data type',
            key: 'dataType',
            isText: true,
            isJSX: false,
            isClickable: false
        },
      
    ],
    docResTableKeys: [
        {
            column_name: '',
            key: 'first_column',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'output',
            key: 'output',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'description',
            key: 'description',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
      
}

export const tableKeysbodyParam = {
    headers: [
        {
            column_name: 'Parameter Name',
            key: 'key',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Type',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Description',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Required',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'Example',
            key: 'value',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
    

    docReqTableKeys: [
        {
            column_name: 'Client',
            key: 'column Name',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'input',
            key: 'input',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'data type',
            key: 'dataType',
            isText: true,
            isJSX: false,
            isClickable: false
        },
      
    ],
    docResTableKeys: [
        {
            column_name: '',
            key: 'first_column',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'output',
            key: 'output',
            isText: true,
            isJSX: false,
            isClickable: false
        },
        {
            column_name: 'description',
            key: 'description',
            isText: true,
            isJSX: false,
            isClickable: false
        }
    ],
      
}

// export const apiData = {
    
//     Value: [
//       { id: 1, column_name: 'API Headers', key: 'header1' },
//       { id: 2, column_name: 'API Headers 2', key: 'header2' },
//       { id: 3, column_name: 'API Headers 3', key: 'header3' },
//     ],
//   };

export const filterParameters = [
    { filterID: '1', filterName: 'All'},
    { filterID: '2', filterName: 'Non Commercial Transactions'},
    // { filterID: '3', filterName: 'e-CAS'},
    { filterID: '3', filterName: 'Read Only'},
    { filterID: '4', filterName: 'Commercial Transactions'},
    { filterID: '5', filterName: 'LAMF'}
]

export const UATOrdersStatus = { 'pending': 'pending', 'processed': 'processed', 'failed': 'failed', 'onhold': 'on hold' }